import { Controller } from '@hotwired/stimulus'
export default class extends Controller {
    static targets = ["content", "overlay"];

    toggle() {
        this.contentTarget.classList.toggle("hidden");
        this.overlayTarget.classList.toggle("hidden");
    }
}
